<template>
  <v-card class="ml">
    <div class="ml__head">
      <div class="ml__head-text">
        <div class="ml__title">{{ entity_name }}</div>
        <div class="ml__sub">{{ $filters.capitalize($t(page_title, 10, { target: entity_name })) }} · {{ maintenances.length }} {{ $t('preventive_maintenances.report', maintenances.length) }}</div>
      </div>
      <v-btn icon="mdi-close" variant="text" density="comfortable" @click="closeMe" :aria-label="$t('close')" />
    </div>
    <v-card-text class="ml__body">
      <div v-if="maintenances.length <= 0" class="ml__empty">{{ $filters.capitalize($t('no_data_text')) }}</div>
      <table v-else class="ml-table">
        <thead>
          <tr>
            <th>{{ $filters.capitalize($t("preventive_maintenances.period.label")) }}</th>
            <th>{{ $filters.capitalize($t("preventive_maintenances.done_at")) }}</th>
            <th class="ml-table__actions"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="maint in maintenances" :key="maint.pk">
            <td><v-chip size="x-small" variant="tonal">{{ $filters.capitalize($filters.formatPeriod(maint.period)) }}</v-chip></td>
            <td class="ml-table__date">{{ $filters.formatDate(maint.done_at) }}</td>
            <td class="ml-table__actions">
              <v-btn
                  v-if="maint.report"
                  size="small"
                  variant="text"
                  color="primary"
                  prepend-icon="mdi-file-pdf-box"
                  :text="$t('actions.download')"
                  @click="openLink(maint.report)"
                  />
              <v-btn
                  icon="mdi-delete-outline"
                  size="small"
                  variant="text"
                  color="error"
                  :aria-label="$t('actions.delete')"
                  @click="deleteItemBtn(maint)"
                  />
            </td>
          </tr>
        </tbody>
      </table>
    </v-card-text>
  </v-card>
</template>

<script>
  import { alertPopup } from "@/functions";

  export default {
    emits: ['close'],
    inject: { dialogClose: { default: null } },
    mounted() {
      // different route for others?
      this.$store
        .dispatch(`${this.module_name}/fromPowerStation`, this.entity_id)
        .then((items) => {
          this.maintenances = items;
        });
    }, 
    props: {
      // entity being power_station for regulatory or producer for the rest
      entity_id: {type: Number, required : true },
      entity_name: {type: String, required : true },
      //    report_type: {type: String, required : true},
      page_title: {type: String, required: true },
      module_name: {type: String, required: true },
    },

    methods: {
      deleteItem(id_) {
        return this.$store.dispatch(`${this.module_name}/deleteItem`, id_);
      },

      deleteItemBtn(item) {
        var index = this.maintenances.findIndex(
          (i) => i.pk === item.pk,
        );
        alertPopup(this.$t("dialog.delete_confirm")).then((result) => {
          if (result && this.maintenances.splice(index, 1)) {
            this.deleteItem(item.pk);
          }
        });
      },
      openLink(url) {
        window.open(url, "_blank");
      },
      closeMe() {
        if (this.dialogClose) this.dialogClose()
        else this.$emit('close')
      },
    },

    data() {
      return {
        showAddReport: false,
        maintenances: [],
      };
    },
  };
</script>
<style scoped>
.ml {
  display: flex;
  flex-direction: column;
  max-height: 100%;
}
.ml__head {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 8px 10px 16px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}
.ml__head-text {
  flex: 1 1 auto;
  min-width: 0;
}
.ml__title {
  font-weight: 700;
  font-size: 1.05rem;
  line-height: 1.25;
}
.ml__sub {
  font-size: 0.8rem;
  color: rgba(0, 0, 0, 0.6);
}
.ml__body {
  overflow-y: auto;
  padding: 0;
}
.ml__empty {
  text-align: center;
  color: rgba(0, 0, 0, 0.55);
  padding: 24px 0;
}
.ml-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.875rem;
}
.ml-table th {
  padding: 8px 12px;
  font-size: 0.7rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: rgba(0, 0, 0, 0.55);
  text-align: left;
  background: #fafafa;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}
.ml-table td {
  padding: 8px 12px;
  vertical-align: middle;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}
.ml-table tbody tr:hover {
  background: rgba(25, 118, 210, 0.05);
}
.ml-table__date {
  font-weight: 600;
  white-space: nowrap;
}
.ml-table__muted {
  color: rgba(0, 0, 0, 0.65);
}
.ml-table__actions {
  width: 1%;
  white-space: nowrap;
  text-align: right;
}
</style>
